export default "__VITE_ASSET__e0f1c132__"